export default __webpack_public_path__ + "static/media/logo-aec.46cbf294.png";